import {IDisableStrategy} from './iDisableStrategy';

export class UntouchedOrInvalidDisableStrategy implements IDisableStrategy {
    isDisabled(mappedOutputValue: any, isFormValid: boolean, isFormTouched: boolean): boolean {
        return !isFormTouched || !isFormValid;
    }
}
